import { Box, useTheme } from "@mui/material";
import {
  Button,
  CheckCircleIcon,
  CopyIcon,
  DownloadIcon,
  PlusIcon,
} from "components";
import {
  useGetDownloadLink,
  useGlobalStore,
  useSetUserAcknowledgement,
} from "controller";
import { useState } from "react";

const DownloadBtn = ({
  variant,
  disabled = false,
  closeDownloadDrawer,
}: {
  variant: string;
  disabled?: boolean;
  closeDownloadDrawer: () => void;
}) => {
  const theme = useTheme();

  const resourceId = useGlobalStore((state) => state.resourceId);
  const mspId = useGlobalStore((state) => state.mspId);

  const { mutateAsync: setAcknowledgement } = useSetUserAcknowledgement();

  const [showCopyLinkSuccess, setShowCopyLinkSuccess] = useState(false);

  const getPlatformAndType = (variant: string) => {
    switch (variant) {
      case "win_exe":
        return { platform: "win", type: "exe" };
      case "win_msi":
        return { platform: "win", type: "msi" };
      case "apple_m":
        return { platform: "mac", type: "arm64" };
      case "apple_intel":
        return { platform: "mac", type: "x64" };
      default:
        return { platform: "win", type: "exe" };
    }
  };
  const { platform, type } = getPlatformAndType(variant);

  const isTeams = variant === "teams";

  const { data: downloadLink, isLoading: isDownloadLinkLoading } =
    useGetDownloadLink({
      type,
      platform,
      mspId: mspId || "",
      enabled: !isTeams,
    });

  // const { data: downloadLink, isLoading: isDownloadLinkLoading } =
  //   useGetDownloadLink({
  //     type: variant,
  //   });

  const handleClick = async (variant: string, mode: string) => {
    const TEAMS_LINK = {
      data: "https://teams.microsoft.com/l/app/0c4388c5-bb07-433d-9ee1-d379351c6844?source=app-details-dialog",
    };
    const data = variant === "teams" ? TEAMS_LINK : downloadLink;
    if (mode === "download") {
      setAcknowledgement(resourceId || "");
      window.open(`${data?.data}`, "_blank");
      closeDownloadDrawer();
    } else if (mode === "copy_link") {
      navigator.clipboard.writeText(data?.data ?? "");
      setShowCopyLinkSuccess(true);
      setTimeout(() => setShowCopyLinkSuccess(false), 2000);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: "16px",
      }}
    >
      <Button
        variant="primary"
        isResponsive={false}
        disabled={disabled || isDownloadLinkLoading}
        onClick={() => handleClick?.(variant, "download")}
        sx={{
          minWidth: "112px",
          borderRadius: "6px",
        }}
        endIcon={
          variant === "teams" ? <PlusIcon fontSize="large" /> : <DownloadIcon />
        }
      >
        {variant === "teams" ? "Add" : "Download"}
      </Button>
      <Button
        variant="secondary"
        isResponsive={false}
        size="small"
        disabled={disabled || isDownloadLinkLoading}
        onClick={() => handleClick?.(variant, "copy_link")}
        sx={{
          minWidth: showCopyLinkSuccess ? "124px" : "112px",
          borderRadius: "6px",
          border: `1px solid ${theme.palette.neutral["020"]}`,
        }}
        endIcon={
          showCopyLinkSuccess ? (
            <CheckCircleIcon color="success" />
          ) : (
            <CopyIcon />
          )
        }
      >
        {showCopyLinkSuccess ? "Link Copied" : "Copy Link"}
      </Button>
    </Box>
  );
};

export { DownloadBtn };
